export class PlatexMessage {
  public message: string;
  public timeStamp: Date;
  public userSent: boolean;
  public seen: boolean;
  public seenTime: Date;
  public noSender: boolean;
}
